import { LS_HAS_LANGUAGE_SCREEN } from '@/constants/common';

import { ClientType } from '@/types/user';

import { readLocal } from './browser';
import { isMobileAdoption } from './user';

type ProgressStep = {
  value: number;
  total: number;
};

type ProgressSteps = {
  languageStep: ProgressStep;
  emailOtpStep: ProgressStep;
  phoneStep: ProgressStep;
  thirdPartyComplianceCheckStep: ProgressStep;
  livenessVerificationStep: ProgressStep;
  livenessConfirmStep: ProgressStep;
  basicInfoStep: ProgressStep;
  addressStep: ProgressStep;
};

const TOTAL_STEPS = 7;

export const PROGRESS_STEPS: ProgressSteps = {
  languageStep: getStep(0, TOTAL_STEPS),
  emailOtpStep: getStep(1, TOTAL_STEPS),
  phoneStep: getStep(2, TOTAL_STEPS),
  thirdPartyComplianceCheckStep: getStep(3, TOTAL_STEPS),
  livenessVerificationStep: getStep(4, TOTAL_STEPS),
  livenessConfirmStep: getStep(5, TOTAL_STEPS),
  basicInfoStep: getStep(6, TOTAL_STEPS),
  addressStep: getStep(7, TOTAL_STEPS),
};

export type MobileAdoptionProgressSteps = {
  emailOtpStep: ProgressStep;
  confirmIdentityStep: ProgressStep;
  completeAdoptionStep: ProgressStep;
};

const TOTAL_MOBILE_ADOPTION_STEPS = 3;

const MOBILE_ADOPTION_STEPS: MobileAdoptionProgressSteps = {
  emailOtpStep: getStep(1, TOTAL_MOBILE_ADOPTION_STEPS),
  confirmIdentityStep: getStep(2, TOTAL_MOBILE_ADOPTION_STEPS),
  completeAdoptionStep: getStep(3, TOTAL_MOBILE_ADOPTION_STEPS),
};

export const getProgressSteps = (clientType?: string) => {
  if (isMobileAdoption(clientType as ClientType)) {
    return MOBILE_ADOPTION_STEPS;
  }
  return PROGRESS_STEPS;
};

export function getStep(currentStep: number, total: number): ProgressStep {
  const hasLanguageScreen = readLocal(LS_HAS_LANGUAGE_SCREEN);
  return {
    value: hasLanguageScreen ? currentStep + 1 : currentStep,
    total: hasLanguageScreen ? total + 1 : total,
  };
}
